import type { ComponentPropsWithRef, FC } from 'react';
import type { Theme } from '@/ui/theme/variables';
import { Flex } from '@ui';
import clsx from 'clsx';
import { useMemo, useState } from 'react';
import { ThemeContext } from '@/ui/theme/ThemeContext';
import { genericVariables, themeVariables } from '@/ui/theme/variables';
import styles from './ThemeProvider.module.css';

export const ThemeProvider: FC<ComponentPropsWithRef<'div'>> = ({ children, className, ...rest }) => {
    const [theme, setTheme] = useState<Theme>('light');

    const value = useMemo(() => ({
        token: { ...themeVariables[theme], ...genericVariables },
        theme,
        setTheme
    }), [theme]);

    return (
        <ThemeContext value={value}>
            <Flex vertical className={clsx(styles.container, styles[`theme-${theme}`], className)} {...rest}>
                {children}
            </Flex>
        </ThemeContext>
    );
};
